import { Img } from "container/Manual/components/content/Image";
import { Paragraph } from "container/Manual/components/content/Paragraph";
import { Li } from "container/Manual/components/list/Li";
import { Ul } from "container/Manual/components/list/Ul";
import { CardSection } from "container/Manual/components/section/CardSection";
import { ListSection } from "container/Manual/components/section/ListSection";

export const ISNUMBER = () => {
  return (
    <CardSection id="ISNUMBER" title="ISNUMBER">
      <Paragraph>
        지정된 열 내의 숫자 값을 확인합니다. 숫자 값이 발견되면 <b>TRUE</b> 값이
        반환됩니다.
      </Paragraph>

      <ListSection title="Syntax">
        <Paragraph accent>ISNUMBER(ARGUMENT)</Paragraph>
        <Ul>
          <Li>
            <b>ARGUMENT</b>는 확인할 열입니다.
          </Li>
        </Ul>
      </ListSection>

      <ListSection title="Example">
        <Paragraph accent>ISNUMBER(`Column`)</Paragraph>
        <Img src="computeIsNumber" />
      </ListSection>
    </CardSection>
  );
};
